import React, { useState } from 'react';

import dayjs from 'dayjs';
import { AthleteRetrieve } from 'types';

import AthleteAttendanceFilters from './components/AthleteAttendanceFilters';
import AthleteAttendanceTableContainer from './components/AthleteAttendanceTableContainer';
import { SearchFilters } from './types';

interface IAttendanceProps {
  athlete: AthleteRetrieve;
  permission?: boolean;
}

const Attendance = ({ athlete, permission }: IAttendanceProps): JSX.Element => {
  const today = new Date();
  const initialSearchFiltersValue: SearchFilters = {
    date: [null, today],
    eventTypes: [],
    athlete: athlete.athleteId,
    weekdays: [],
    isBulkAdd: null,
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [orderingValue, setOrderingValue] = useState('-startDate');

  return (
    <>
      <AthleteAttendanceFilters
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
        orderingValue={orderingValue}
        timeType='past'
        defaultEndDate={dayjs(today).format('YYYY-MM-DD')}
      />

      <AthleteAttendanceTableContainer
        searchFilters={searchFilters}
        permission={permission}
        timeType='past'
        defaultEndDate={dayjs(today).format('YYYY-MM-DD')}
        setOrderingValue={setOrderingValue}
        athleteName={athlete.fullName}
        showProfileParityColumns
      />
    </>
  );
};

export default Attendance;
